// extracted by mini-css-extract-plugin
export var quantityInput = "_fq-0";